import React from 'react';

interface LinkProps {
  href: string;
}

export default function Link({ children, href }: React.PropsWithChildren<LinkProps>) {
  return React.cloneElement(React.Children.only(children) as React.ReactElement, { href });
}
